import "./storeUtm";
import { initRudderStack } from "./analytics/rudderstack-client";
import { initAnalyticsEvents } from "./analytics/events";
import { flushPendingExposures } from "./analytics/posthog-exposure";

initRudderStack();
initAnalyticsEvents();
flushPendingExposures();

function initSentryWhenIdle(): void {
    void import("./sentry-blade");
}

if (typeof window !== "undefined" && "requestIdleCallback" in window) {
    requestIdleCallback(() => initSentryWhenIdle(), { timeout: 5000 });
} else {
    setTimeout(initSentryWhenIdle, 3000);
}
import "./blade-icons";
import "./header/header-mode";
import "./header/assets";
// Photos du bandeau de l'accueil A / B (manifeste Vite)
import "./home/hero-ab-assets";
import "./header/header-menu";
import "./header/header-dropdown";
import { initCompareFavorite } from "./marketplace/widgets/compare-favorite";
initCompareFavorite();
import "./shared/toast";
// Carte véhicule touchée : assombrie jusqu'à l'ouverture de la fiche
import "./shared/card-press";
// Page de liste (marketplace, landing, page dynamique : barre de filtres, classe `mkt-bar--*` posée par
// layouts/blade) : au retour d'une fiche, la carte touchée revient à sa place
import { initListReturnAnchor } from "./marketplace/list-return-anchor";
if (/\bmkt-bar--/.test(document.body.className)) initListReturnAnchor();

let loginModalPromise: Promise<typeof import("./shared/login-modal")> | null = null;

function handleOpenLoginModal(): void {
    loginModalPromise ??= import("./shared/login-modal");
    void loginModalPromise.then((mod) => mod.openLoginModal());
}

window.addEventListener("open-login-modal", handleOpenLoginModal);

// Client suivi : volet (téléphone) ou panneau (ordinateur) de son conseiller dédié
// (partials/sales-advisor-header, partials/sales-advisor-desktop)
if (document.querySelector("[data-advisor-open], [data-advisor-desk-open]")) {
    void import("./header/sales-advisor-sheet");
}

function loadAutocompleteIfNeeded(): void {
    const hasCompactMobileHeader = document.querySelector(
        '.header__container[data-compact-mobile-header="true"]',
    );

    const hasAutocomplete =
        document.getElementById("header-autocomplete") ||
        (document.getElementById("header-autocomplete-mobile") &&
            !hasCompactMobileHeader) ||
        document.getElementById("home-autocomplete");

    if (hasAutocomplete) {
        void import("./shared/blade-autocomplete");
    }
}

function loadIntroExpandIfNeeded(): void {
    if (document.querySelector("[data-intro-toggle]")) {
        void import("./landing-model/intro-expand");
    }
}

const PAGES_WITH_ACCORDIONS = new Set([
    "home",
    "marketplace",
    "vehicle-show",
    "landing",
    "landing-model",
    "dynamic-page",
]);

function loadPageModules(): void {
    const page = document.body.dataset.page;

    if (page && PAGES_WITH_ACCORDIONS.has(page)) {
        void import("./home/accordion");
    }

    if (page === "vehicle-show") {
        void import("./vehicle-show/gallery");
        void import("./vehicle-show/trust-dialog");
        void import("./vehicle-show/calculator");
        void import("./vehicle-show/price-tooltip");
        if (document.querySelector("[data-offer-card]")) {
            void import("./vehicle-show/offer-card").then((mod) => mod.initOfferCard());
        }
        void import("./vehicle-show/support-link");
        void import("./vehicle-show/delivery-banner");
        void import("./vehicle-show/options-catalogue");
        if (document.querySelector("[data-registration-tax]")) {
            void import("./vehicle-show/registration-tax");
        }
        return;
    }

    if (page === "home") {
        void Promise.all([
            import("./home/brands-banner").then((mod) => mod.initBrandsBanner()),
            import("./home/car-visualization"),
            import("./home/press-carousel"),
            import("./home/sticky-bar"),
            import("./home/vehicle-card-carousel"),
            import("./home/locomotive-scroll"),
            // Accueil actuel seulement : les menus Marque / Modèle / Carburant / Prix du bandeau
            document.getElementById("hero-filter-bar")
                ? import("./home/home-hero-filters")
                      .then((mod) => mod.initHomeHeroFilters())
                      .catch((error) => {
                          console.error("[blade-app] home-hero-filters failed", error);
                      })
                : null,
            // Test « place de la recherche » : exposition au chargement (visiteur compté seulement)
            window.__AB__?.["exp-202611-home-search"]
                ? import("./home/ab-home-search").then((mod) => mod.trackHomeSearchExposure())
                : null,
            // Accueil A / B (test « place de la recherche ») : champ(s) de recherche et suggestions
            document.querySelector("[data-home-search]")
                ? import("./home/home-search")
                      .then((mod) => mod.initHomeSearch())
                      .catch((error) => {
                          console.error("[blade-app] home-search failed", error);
                      })
                : null,
        ]);
        return;
    }

    if (page === "landing") {
        void import("./landing/landing-page-header");
        return;
    }

    if (page === "sold-vehicles") {
        // Card photo carousels (arrows + counter), as on the home page.
        void import("./home/vehicle-card-carousel");
        return;
    }

    if (page === "landing-model") {
        void import("./landing/landing-page-header");
    }
}

loadAutocompleteIfNeeded();
loadIntroExpandIfNeeded();
loadPageModules();
